import { AsyncCtx, atom, reatomAsync } from "@reatom/framework";
import {
  getCurrentServiceCard,
  getSummaryCurrentService,
} from "../../../api/requests/getCurrentService";
import { ErrorInterface } from "../../types/request";
import { AxiosError } from "axios";

export interface Files {
  id: number;
  name: string;
  source_name: string;
  mime_type: string;
  size: number;
  meta: null;
  private: boolean;
  url: string;
  url_preview: string | null;
  type: string;
  virus: boolean;
  virus_type: number;
  width: number;
}

export interface CurrentServiceInterface {
  id: number;
  user: {
    id: number;
    photo_url: string;
    pro: boolean;
    profi: boolean;
    top_expert: boolean;
    reg_date: number;
    username: string;
    full_name: string;
    first_name: string;
    surname: string;
  };
  title: string;
  days: number;
  price: CalculatePrice;
  profession: string | null;
  description: string;
  emp_requirement: string;
  emp_result: string;
  links_video: [];
  is_meet: boolean;
  city: string | null;
  skills: [];
  specs: {
    id: number;
    name: string;
    prof_group: {
      id: number;
      name: string;
    };
  }[];

  professionIds: number[];
  files: Files[];
  preview_files: Files[];
  active: boolean;
  total_feedbacks: number;
  views_count: number;
  count_sold: number;
  date_post: Date;
  date_edit: Date;
  extra: {
    id: number;
    title: string;
    result: string;
    price_emp: number;
    price: number;
    days: string;
  }[];
  url: string;
  is_work: boolean;
  pay_from_account: boolean;
}

export interface CalculatePrice {
  amount: number;
  currency: string;
}

export const currentServiceAtom = atom<CurrentServiceInterface | null>(
  null,
  "currentServiceAtom"
);

export const currentServiceErrorAtom = atom<null | ErrorInterface>(
  null,
  "errorAtom"
);
export const currentServiceIsLoadingAtom = atom(true, "isLoadingAtom");
export const extraAtom = atom<number[]>([], "extraAtom");
export const currentServiceAction = reatomAsync(
  async (ctx: AsyncCtx, id: string) => {
    currentServiceIsLoadingAtom(ctx, true);
    extraAtom(ctx, []);
    const response = await getCurrentServiceCard(id);
    return response;
  },
  {
    name: "currentServiceAction",
    onFulfill: (_ctx, data) => {
      currentServiceAtom(_ctx, data);
      currentServiceIsLoadingAtom(_ctx, false);
    },
    onReject: (_ctx, error) => {
      const serverError = error as AxiosError<ErrorInterface>;

      currentServiceErrorAtom(_ctx, {
        error: serverError.response?.data?.error,
        description: serverError.response?.data?.description,
        code: serverError.response?.status,
      });
      currentServiceIsLoadingAtom(_ctx, false);
    },
  }
);

export const currentServiceIsLoadingCalculateAtom = atom(
  false,
  "isLoadingCalculateAtom"
);

export const currentServiceCalculateAction = reatomAsync(
  async (ctx: AsyncCtx, id: string, extra: number[]) => {
    currentServiceIsLoadingCalculateAtom(ctx, true);
    const response = await getSummaryCurrentService(id, extra);
    return response;
  },
  {
    name: "currentServiceCalculateAction",
    onFulfill: (_ctx, data) => {
      const prev = _ctx.get(currentServiceAtom);
      if (prev) {
        currentServiceAtom(_ctx, { ...prev, price: data });
      }
      currentServiceIsLoadingCalculateAtom(_ctx, false);
    },
    onReject: (_ctx) => {
      currentServiceIsLoadingCalculateAtom(_ctx, false);
    },
  }
);
